// CORE-1735 slice 17 (D-120, QA V06) — Live icon «record» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Circle } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Record: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Circle cx={12} cy={12} r={6} fill={color} />
    </G>
  </Svg>
);
